import React, { Component } from 'react';
import { getDollarFormat } from 'utils/helpers';
import { connect } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import { getOrders } from 'actions/DashboardActions';
class dbOrders extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { orders } = this.props || {};
        const { completedForDay = 0, completedForWeek = 0, completedForMonth = 0, 
                amountForDay = 0, amountForWeek = 0, amountForMonth = 0,
                taxForDay = 0, taxForWeek = 0, taxForMonth = 0
             } = orders || {};


        return (
            <div id="chart1" className="item col-4-p-0 pb-3 ml-3">
                <DashDialog
                    text="Transactions"
                    link="/report/sales-summary-details"
                    classicClass="bg-ClassicBlue"
                    isReport={true}
                    refreshAction={() => this.props.getOrders(this.props.branchId)} />

                {
                    this.props.loading
                        ?
                        <ClipLoader
                            size={50}
                            color={'#123abc'}
                            loading={true}
                        />
                        :
                        <div className="orders_height">
                            <div className="row p-0 m-0">
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label className="db-label mb-0 mt-5">Today</label>
                                    <h2 className="db-data mt-0 mb-0 green-text">{!completedForDay ? "0" : completedForDay}</h2>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label className="db-label mb-0 mt-5">This Week</label>
                                    <h2 className="db-data mt-0 mb-0 green-text">{!completedForWeek ? "0" : completedForWeek}</h2>
                                    {/* <h5 className="mt-4 mb-0 dashBoradTotalText">Avg: <font className="blue-text">{(completedForWeek == 0 || amountForWeek == 0 || amountForWeek === null || amountForWeek === undefined || completedForWeek === null || completedForWeek === undefined) ? "$0" : getDollarFormat(amountForWeek / completedForWeek)}</font></h5> */}
                                    {/* <h5 className="mt-4 mb-0 dashBoradTotalText">Avg Ex Tax: <font className="blue-text">{(completedForWeek == 0 || taxForWeek == 0 || taxForWeek === null || taxForWeek === undefined || completedForWeek === null || completedForWeek === undefined)? "$0" : getDollarFormat(taxForWeek / completedForWeek)}</font></h5> */}
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label className="db-label mb-0 mt-5">This Month</label>
                                    <h2 className="db-data mt-0 mb-0 green-text">{!completedForMonth ? "0" : completedForMonth}</h2>
                                </div>
                                <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                                    <h5 className='purpleText text-left'>Including Tax</h5>
                                    <div className='grayBox' >
                                        <div className='d-flex justify-content-around db-orders'>
                                            <div className='mb-1'>
                                                <h5 className="dashBoradTotalText">
                                                    <span>Net Sales: </span>
                                                    <font className="green-text">{!amountForDay ? "$0" : getDollarFormat(amountForDay)}</font></h5>
                                                <h5 className="mt-4 dashBoradTotalText">
                                                    <span>Avg: </span>
                                                    <font className="blue-text">{!completedForDay || !amountForDay ? "$0" : getDollarFormat(amountForDay / completedForDay)}</font></h5>
                                            </div>
                                            <div className='mb-1'>
                                                <h5 className="dashBoradTotalText">
                                                    <span>Net Sales: </span>
                                                    <font className="green-text">{!amountForWeek ? "$0" : getDollarFormat(amountForWeek)}</font></h5>
                                                <h5 className="mt-2 dashBoradTotalText">
                                                    <span>Avg: </span>
                                                    <font className="blue-text">{!completedForWeek || !amountForWeek ? "$0" : getDollarFormat(amountForWeek / completedForWeek)}</font></h5>
                                            </div>
                                            <div className='mb-1'>
                                                <h5 className="dashBoradTotalText">
                                                    <span>Net Sales: </span>
                                                    <font className="green-text">{!amountForMonth ? "$0" : getDollarFormat(amountForMonth)}</font></h5>
                                                <h5 className="mt-2 dashBoradTotalText">
                                                    <span>Avg: </span>
                                                    <font className="blue-text">{!completedForMonth || !amountForMonth ? "$0" : getDollarFormat(amountForMonth / completedForMonth)}</font></h5>
                                            </div>
                                        </div>
                                    </div>
                                    <h6 className='purpleText text-left'>Excluding Tax</h6>
                                    <div className='grayBox'>
                                        <div className='d-flex justify-content-around db-orders'>
                                            <div className='mb-1'>
                                                <p className="dashBoradTotalText">
                                                    <span>Net Sales: </span>
                                                    <font className="green-text">{!taxForDay ? "$0" : getDollarFormat(taxForDay)}</font>
                                                </p>
                                                <h5 className="mt-4 dashBoradTotalText">
                                                    <span>Avg: </span>
                                                    <font className="blue-text">{!taxForDay || !completedForDay ? "$0" : getDollarFormat(taxForDay / completedForDay)}</font></h5>
                                            </div>
                                            <div className='mb-1'>
                                                <h5 className="dashBoradTotalText">
                                                    <span>Net Sales: </span>
                                                    <font className="green-text">{!taxForWeek ? "$0" : getDollarFormat(taxForWeek)}</font></h5>
                                                <h5 className="mt-2 dashBoradTotalText">
                                                    <span>Avg: </span>
                                                    <font className="blue-text">{!taxForWeek || !completedForWeek ? "$0" : getDollarFormat(taxForWeek / completedForWeek)}</font></h5>
                                            </div>
                                            <div className='mb-1'>
                                                <h5 className="dashBoradTotalText">
                                                    <span>Net Sales: </span>
                                                    <font className="green-text">{!taxForMonth ? "$0" : getDollarFormat(taxForMonth)}</font></h5>
                                                <h5 className="mt-2 dashBoradTotalText">
                                                    <span>Avg: </span>
                                                    <font className="blue-text">{!taxForMonth || !completedForMonth ? "$0" : getDollarFormat(taxForMonth / completedForMonth)}</font></h5>
                                            </div>
                                        </div>
                                    </div>
                                        {/* <h5 className="mt-4 mb-0 dashBoradTotalText">Avg: <font className="blue-text">{(completedForDay == 0 || amountForDay == 0 || amountForDay === null || amountForDay === undefined || completedForDay === null || completedForDay === undefined)? "$0" : getDollarFormat(amountForDay / completedForDay)}</font></h5> */}
                                        {/* <h5 className="mt-4 mb-0 dashBoradTotalText">Avg Ex Tax: <font className="blue-text">{(completedForDay == 0 || taxForDay == 0 || taxForDay === null || taxForDay === undefined || completedForDay === null || completedForDay === undefined)? "$0" : getDollarFormat(taxForDay / completedForDay)}</font></h5> */}
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.common.dbOrdersCall > 0,
        branchId: state.common.branchId,
    }
}

function mapDispatchToProps(dispatch){
    return {
        getOrders: (branchId) => dispatch(getOrders(branchId, true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(dbOrders);
